module.exports = __webpack_public_path__ + "img/ICON2.467a0228.png";